import { render, staticRenderFns } from "./index.vue?vue&type=template&id=df40778e"
import script from "./dashboardDetail.js?vue&type=script&lang=js&external"
export * from "./dashboardDetail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports